import { displayElem } from '../functions/displayElem';
import { updateText } from '../functions/updateText';

export const handle403 = next => async ({ directive, meta, error, tries, resolved }) => {

  // 403 Forbidden: The user does not have sufficient permissions to complete the request.!
  if (!resolved && error.status === 403) {
    updateText('#feedback', "INCORRECT PASSWORD");
    displayElem('#loadingOverlay', 'none');
    displayElem('#passwordForm', 'inline-block');
    resolved = true;
  }

  return next({ directive, meta, error, tries, resolved });
};
